export const EXPORTS_LOADING = 'EXPORTS_LOADING';
export const GET_SAVED_EXPORTS = 'GET_SAVED_EXPORTS';
export const GET_SAVED_EXPORTS_ERROR = 'GET_SAVED_EXPORTS_ERROR';
export const SAVED_EXPORTS_CLEAR_ERROR = 'SAVED_EXPORTS_CLEAR_ERROR';
export const SAVED_EXPORT_DELETE_SUCCESSFUL = 'SAVED_EXPORT_DELETE_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/exportlist/types.js